import styled from 'styled-components';

export const HighlightContent = styled.div``;

export const StarHighLightTop = styled.div`
  display: flex;
  align-items: center;
`;
export const StarHighLightDown = styled.div`
  display: flex;
  align-items: center;
`;

export const FeatureHighLightContainer = styled.div`
  position: relative;

  ${StarHighLightTop} {
    position: absolute;
    right: 8px;
    top: -12px;

    svg {
      width: 12px;
      height: 12px;
    }
  }

  ${StarHighLightDown} {
    position: absolute;
    right: -8px;
    top: -6px;

    svg {
      width: 24px;
      height: 24px;
    }
  }

  ${HighlightContent} > * {
    border: 2px solid #4676fa !important;
  }
`;

export const ToolTipContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;

  width: 28px;

  ${StarHighLightTop} {
    position: absolute;
    right: 20px;
    top: 4px;

    svg {
      width: 12px;
      height: 12px;
    }
  }

  ${StarHighLightDown} {
    position: absolute;
    top: 8px;

    svg {
      width: 24px;
      height: 24px;
    }
  }
`;

export const Right = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`;

export const Title = styled.span`
  color: var(--Black-Alpha-100, #666);
  /* Heading Small 14 */
  font-family: 'Source Sans Pro';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const Content = styled.span`
  color: var(--Gray-300, #75777f);
  /* Heading Small 12 */
  font-family: 'Source Sans Pro';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
